module.exports = __webpack_public_path__ + "img/logo_404.d15da5c9.svg";